import React from 'react';

import { AppFormLayout, AppForm, AppFormPageProps, AppFormItemEnum, AppButton, AppAction, AppRow } from 'qcc'
import api, { TemplateOption, MetadataOption } from "api";
import { message } from "antd";

export default class SetBillTemplateForm extends React.PureComponent<AppFormPageProps> {
  state = {
    sealName: '',
    remarks: ''
  }

  onTemplateChange = (formData?: any) => {
    let { templateOptionList } = this.props.formData;
    let { templateId } = formData;
    let templateObj = getCurrTemplateOption(templateId, templateOptionList);
    let sealName = templateObj.sealName || '';
    let newFormData = { ...formData, sealName };
    this.refForm.current && this.refForm.current.onValueChange(newFormData);
    this.setState({ sealName })
  }
  // onRemarksChange = (formData?: any) => {
  //   let { templateOptionList } = this.props.formData;
  //   let { remarks } = formData;    
  //   this.setState({ remarks })
  // }
  // 生成票据
  generateBill = async (preview: number) => {
    let formData = this.refForm.current.getFormData();
    let templateId = formData.templateId || 0;
    if (templateId === 0) return;

    AppAction.coverFull()

    // 第一步：先生成需要的vouch数据
    let { getInFeeIdList, project_id } = formData;
    let mode = 'POS'
    let projectId = project_id;
    let res0 = await api.posapp.checkVoucherStatus({ getInFeeIdList, mode, projectId });
    if (!res0.result) {
      AppAction.cancelCoverFull();
      AppAction.alert(res0.msg);
      return;
    }

    let res = await api.posvoucher.create({ getInFeeIdList, mode, projectId, remarks: formData.remarks, preview });
    if (!res.result) {
      AppAction.cancelCoverFull();
      AppAction.alert(res.msg);
      return;
    }

    // 第二步：调用生成电子票据的方法
    let voucher = res.data as any;
    let voucherId = voucher.id;
    let res2 = await api.wisdomcashiertemplate.GenerateBill({ voucherId, templateId, preview })
    if (!res2.result) {
      AppAction.cancelCoverFull();
      AppAction.alert(res2.msg);
      return;
    }
    message.success(preview === 1 ? '预览电子票据!' : '生成电子票据!');

    if (preview === 1) {
      window.open(`${res2.data}`)
      AppAction.cancelCoverFull();
    } else {
      let res3 = await api.posapp.getCreatereceipt({ "voucherId": voucherId })
      // 第三步：向SAP传数据  待陈奇实现
      if (!res3.result) {
        AppAction.cancelCoverFull();
        AppAction.alert(res3.msg);
        return;
      }

      message.success('生成电子票据，并传递给SAP成功！');
      AppAction.cancelCoverFull();

      this.props.afterSave && this.props.afterSave();
      AppAction.closeDialog()
    }

  }


  close = async () => {
    AppAction.closeDialog()
  }


  refForm = React.createRef<AppForm>();

  render() {
    let { formData, mode, id } = this.props;
    let { templateOptionList } = formData;
    return (<AppFormLayout >
      <AppFormLayout.Form>
        <AppForm entity='' loadingData={false} mode={mode} keyValue={id} formData={formData}
          afterSave={() => { this.props.afterSave && this.props.afterSave() }}
          ref={this.refForm}
        >
          <AppForm.Section labelWidth={120} >
            <AppForm.Item label='客户名称'
              field='customer_name'
              itemType={AppFormItemEnum.label} readonly />

            <AppForm.Item label='POS票号'
              field='pos_code'
              itemType={AppFormItemEnum.label} readonly />

            <AppForm.Item label='收据金额'
              field='amount'
              itemType={AppFormItemEnum.input} dataType='number' readonly />

            <AppForm.Item label='收据模板'
              field='templateId'
              onFormItemChange={this.onTemplateChange}
              options={getOptions(templateOptionList)}
              itemType={AppFormItemEnum.select} dataType='number' />

            <AppForm.Item label='收据签章'
              render={() => {
                return <span>{this.state.sealName}</span>
              }} />
            <AppForm.Item field='remarks' maxLength={20} itemType={AppFormItemEnum.text} label="备注" />
          </AppForm.Section>
        </AppForm>
      </AppFormLayout.Form>
      <AppFormLayout.Footer>
        <AppRow>
          <AppButton label="预览收据" actionCode="66101001" type='primary' action={() => this.generateBill(1)} />
          <AppButton label="生成收据" actionCode="66101001" type='primary' action={() => this.generateBill(0)} />
          <AppButton label="关闭" action={() => this.close()} />
        </AppRow>
      </AppFormLayout.Footer>
    </AppFormLayout>)
  }
}

const getOptions = (options?: TemplateOption[]) => {
  return options.map((opt: TemplateOption) => {
    return { value: opt.id.toString(), label: opt.templateName } as MetadataOption
  }) || [] as MetadataOption[]
}

const getCurrTemplateOption = (id?: number, options?: TemplateOption[]) => {
  return options.find(o => o.id === id) || {} as TemplateOption;
}


// WEBPACK FOOTER //
// ./src/page/pos/getin/SetBillTemplateForm.tsx